import VersionModel from './version.ts';

export default class EmployeeVersionModel extends VersionModel {}
